module.exports = __webpack_public_path__ + "static/media/icon_complete.63fa0fde.svg";